import React from 'react';
import Section from "../../../components/Section.jsx";
import DataBlock from "../../../components/DataBlock.jsx";
import {Button} from "semantic-ui-react";

const ParcelParamsBlock = ({footerContent, titleContent, children, onClick}) => {
    return (
        <DataBlock
            label={'Укажите параметры отправления'}
        >
            <Section
                footerContent={footerContent}
                titleContent={titleContent}
            >
                {children}
            </Section>
            <div className='step-btn-block'>
                <Button className='step-btn-block__btn' color={'blue'} onClick={onClick}>
                    Подобрать тариф
                </Button>
            </div>
        </DataBlock>
    );
};

export default ParcelParamsBlock;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/parcelParamsBlock.jsx